// Kilja: load the cart dropdown body (section kilja-mini-cart) when it is about to open.
(function () {
  const wrap = document.querySelector('[data-kilja-mini-cart]');
  if (!wrap) return;
  const body = wrap.querySelector('[data-kilja-mini-cart-body]');
  let loading = null;
  function load() {
    if (loading) return loading;
    loading = fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=kilja-mini-cart' : '/?sections=kilja-mini-cart')
      .then((r) => r.json())
      .then((d) => { if (d['kilja-mini-cart']) body.innerHTML = d['kilja-mini-cart']; })
      .catch(() => {})
      .finally(() => { setTimeout(() => { loading = null; }, 1500); });
    return loading;
  }
  wrap.addEventListener('mouseenter', load);
  wrap.addEventListener('focusin', load);
})();

// Kilja: "Fara efst" back-to-top button.
(function () {
  const btn = document.getElementById('kilja-top');
  if (!btn) return;
  const toggle = () => btn.classList.toggle('is-active', window.scrollY > 200);
  window.addEventListener('scroll', toggle, { passive: true });
  toggle();
  btn.addEventListener('click', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
